<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col>
            <ExportSidebar
              sidebar-id="sidebar-customers-export"
              storage-key="sidebar_customers_export"
              :columns="customersExportColumns"
              :data-to-export="items"
              :data-mapper="mapCustomerForExport"
              file-name="Customers.xlsx"
              sheet-name="Customers"
              :is-busy="isBusy"
              :items-count="totalRows"
            />
          </b-col>
          <b-col cols="auto">
            <b-button id="table-settings" size="sm" variant="warning" class="mr-2" v-b-toggle.sidebar-fields>
              <font-awesome-icon icon="cog"/>
            </b-button>
            <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
              Колонки
            </b-tooltip>
            <b-button
              v-if="canEditCustomers()"
              size="sm"
              variant="success"
              :disabled="isBusy"
              @click="showModal(null, false)"
            >
              <b-spinner v-if="isBusy" small/>
              <font-awesome-icon icon="plus" class="mr-1"/>
              {{ $t("message.customers.importHand") }}
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar variant="light">
      <b-navbar-nav>
        <filters-drawer
      :query.sync="filters.query"
      :is-busy="isBusy"
      :filter-tags="activeFilterTags"
      @remove-tag="removeFilterTag"
      @submit="onSearch"
      @clear="onClearFilters"
    >
      <b-col md="6" cols="12">
        <label class="small text-muted">Города</label>
        <b-form-select
          id="input-town"
          size="sm"
          v-model="filters.town"
        >
          <option :value="-1">Все города</option>
          <option v-for="option in towns" :value="option.id">
            {{ option.name }}
          </option>
        </b-form-select>
      </b-col>
      <b-col md="6" cols="12">
        <label class="small text-muted">Тип</label>
        <b-form-select
          id="input-urflag"
          size="sm"
          v-model="filters.urflag"
          :options="urflagOptions"
        />
      </b-col>
    </filters-drawer>
      </b-navbar-nav>
    </b-navbar>
    <b-table
      id="customers"
      ref="customers"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"/>
          <strong>Загрузка</strong>
        </div>
      </template>
      <template #cell(address)="row">
        <div v-if="row.item.address.length<50">{{ row.item.address }}</div>
        <div v-else>{{ row.item.address.substring(0, 50) + ".." }}</div>
      </template>
      <template #cell(action)="row">
        <b-dropdown size="sm" no-caret>
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v"/>
          </template>
          <b-dropdown-item-button variant="success" @click.stop="showModal(row.item.id,true)">
            <font-awesome-icon icon="eye"/>
            Смотреть
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditCustomers()" variant="primary" @click.stop="showModal(row.item.id,false)">
            <font-awesome-icon icon="edit"/>
            Редактировать
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditCustomers()" variant="danger" @click.stop="onRemove(row)">
            <font-awesome-icon icon="trash"/>
            Удалить
          </b-dropdown-item-button>
        </b-dropdown>
      </template>

      <template #cell(phone)="row">
        <a :href=telUrl(row.item.phone)>{{phoneString(row.item.phone)}}</a>
      </template>

      <template #cell(urflag)="row">
        {{urFlagString(row.item.urflag)}}
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <customer ref="customer" v-on:refresh="getItems" @modal-closed="onModalClosed"/>

    <dynamic-tables
      storage-key="customers_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      :serviceEndField="serviceEndField"
      fieldKey="name"
    />

  </div>
</template>

<script>
import customers from "../../network/customers";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import permissions, {PERM} from "../../utilites/permissions";
  import ExportSidebar from "../../utilites/commonUi/ExportSidebar.vue";
  import pageSearchService from "../../utilites/pageSearchService";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
    import Customer from "./Customer";

export default {
  name: 'Customers',
  components: { ExportSidebar, FiltersDrawer, DynamicTables, Customer, PaginationFooter },
  mixins: [
    customers, catalogs,
    helpers, permissions, pageSearchService
  ],
  data() {
    return {
      title: 'Заказчики',
      items: [],
      fields: [
        {
          key: 'name',
          label: this.$t('message.customers.table.name'),
          sortable: false,
          class: 'customersName',
          visible: true
        },
        {
          key: 'inn',
          label: this.$t('message.customers.table.inn'),
          sortable: false,
          visible: true
        },
        {
          key: 'kpp',
          label: this.$t('message.customers.table.kpp'),
          sortable: false,
          visible: true
        },
        {
          key: 'ogrn',
          label: this.$t('message.customers.table.ogrn'),
          sortable: false,
          visible: true
        },
        {
          key: 'phone',
          label: this.$t('message.customers.table.phone'),
          sortable: false,
          visible: true
        },
        {
          key: 'address',
          label: this.$t('message.customers.table.address'),
          sortable: false,
          visible: true
        },
        {
          key: 'urflag',
          label: this.$t('message.customers.table.urflag'),
          sortable: false,
          visible: true
        },
      ],
      serviceEndField: {
        key: 'action',
        label: this.$t('message.customers.table.actions'),
        class: 'customersAction'
      },
      towns: [],
      urflagOptions: [
        { value: null, text: 'Показывать все' },
        { value: 'true', text: 'Юр лицо' },
        { value: 'false', text: 'Физ лицо' },
      ],
      sortBy: 'id',
      sortDesc: true,
      isBusy: false,
      filters: this.getDefaultFilters(),
      deleteRow: {
        id: null,
        name: '',
      },
      customersExportColumns: {
        "Имя": true,
        "ИНН": true,
        "КПП": true,
        "ОГРН": true,
        "Телефон": true,
        "Адрес": true,
        "Тип": true,
      },
    }
  },
  async created() {
    this.isBusy = true;
    const query = this.$route.query;

    if (query) {
      if (query.query) this.filters.query = query.query;

      if (query.town) this.filters.town = query.town;

      if (query.urflag) {
        if (query.urflag === 'true') {
          this.filters.urflag = true;
        } else {
          this.filters.urflag = query.urflag === 'false' ? false : null;
        }
      }
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    this.towns = (await this.getTowns({})).data.items;
    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [
        this.serviceStartField,
        ...this.visibleFields,
        this.serviceEndField
      ];
    },
    activeFilterTags() {
      const tags = [];
      const defaults = this.getDefaultFilters();

      if (this.filters.town !== defaults.town) {
        const foundItem = this.towns.find(s => s.id === this.filters.town);
        tags.push({ key: 'town', label: foundItem ? foundItem.name : 'Город' });
      }

      if (this.filters.urflag !== defaults.urflag) {
        const foundItem = this.urflagOptions.find(s => s.value === this.filters.urflag);
        tags.push({ key: 'urflag', label: foundItem ? foundItem.text : 'Тип' });
      }

      return tags;
    },
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        town: this.filters.town,
        urflag: this.filters.urflag,
      }

      this.isBusy = true;
      const result = await this.getCustomers(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
    },
    showModal(customerId, isViewonly) {
      const canEdit = this.canEditCustomers();

      if (!customerId) {
        if (!canEdit) return;

        this.$refs.customer.showModal(null, false);
        return;
      }

      const isView = isViewonly || !canEdit;
      const query = isView ? { mode: 'view' } : {};

      this.$router.push({
        name: 'Customers',
        params: { id: customerId },
        query: query
      });
    },
    onRowClicked(item) {
      this.showModal(item.id, false);
    },
    onModalClosed() {
      if (this.$route.params.id) {
        this.$router.replace({
          name: 'Customers',
          params: { id: null },
          hash: this.$route.hash,
        }).catch(()=>{});
      }
    },
    onRemove(row) {
      if (!this.canEditCustomers()) return;

      if (row.item) {
        this.deleteRow = row.item
      }

      const title = "Удаление заказчика";
      const message = `Вы действительно хотите удалить заказчика "${this.deleteRow.name}"?`;
      this.showModalDelete(title, message, async () => {

        const result = await this.deleteCustomer(this.deleteRow);

        if (result.error) {
          this.showToast('Ошибка при удалении.', 'Ошибка', 'danger');
        } else {
          this.showToast('Заказчик удалён.', 'Успех', 'success');
          await this.getItems();
        }
      });
    },
    urFlagString(flag) {
      return flag ? "Юр лицо" : "Физ лицо";
    },
    // Filters
    getDefaultFilters() {
      return {
        query: '',
        town: -1,
        urflag: null
      }
    },
    onClearFilters() {
      const filters = this.getDefaultFilters();

      if (JSON.stringify(this.filters) === JSON.stringify(filters)) return;

      this.filters = filters;
      this.onSearch();
    },
    removeFilterTag(tag) {
      if (tag.key === 'town') {
        this.filters.town = -1;
      }
      if (tag.key === 'urflag') {
        this.filters.urflag = null;
      }
      this.onSearch();
    },
    // Export
    mapCustomerForExport(item, selectedColumns) {
      const config = {
        "Имя": item.name,
        "ИНН": item.inn,
        "КПП": item.kpp,
        "ОГРН": item.ogrn,
        "Телефон": item.phone,
        "Адрес": item.address,
        "Тип": item.urflag,
      };
      const excelData = {};

      for (const key in config) if (selectedColumns[key]) {
        excelData[key] = config[key];
      }
      return excelData;
    },
    // Permissions
    canEditCustomers() {
      return this.hasPermission([PERM.CUSTOMER_EDIT]);
    },
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        this.$nextTick(() => {
          if (newId && this.$refs.customer) {
            const isViewonly = this.$route.query.mode === 'view';
            this.$refs.customer.showModal(newId, isViewonly);
          } else if (!newId && this.$refs.customer) {
            this.$refs.customer.hideModal();
          }
        });
      }, immediate: true
    },
  }
}
</script>

<style>
@media screen
and (min-width: 768px) {
  a[href*="tel:"] {
    pointer-events: none;
    cursor:default;
    text-decoration: none;
  }
}

.customersName {
  padding-left: 10px !important;
  min-width: 200px;
  max-width: 300px;
}

.customersAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}

#customers td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Customers/Customers.vue